import { render, staticRenderFns } from "./Thing.vue?vue&type=template&id=b2206542&scoped=true&"
import script from "./Thing.vue?vue&type=script&lang=ts&"
export * from "./Thing.vue?vue&type=script&lang=ts&"
import style0 from "./Thing.vue?vue&type=style&index=0&id=b2206542&lang=scss&scoped=true&"
import style1 from "./Thing.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2206542",
  null
  
)

export default component.exports